// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    // apiKey: import.meta.env.VITE_API_KEY, 
    // authDomain: import.meta.env.VITE_AUTH_DOMAIN,
    // projectId: import.meta.env.VITE_PROJECT_ID,
    // storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
    // messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
    // appId: import.meta.env.VITE_APP_ID

  apiKey: "AIzaSyA5GfHygNdGjZtK9kmuAdjmR2wag577thg",
  authDomain: "stops-indicator-base.firebaseapp.com",
  projectId: "stops-indicator-base",
  storageBucket: "stops-indicator-base.firebasestorage.app",
  messagingSenderId: "93000457080",
  appId: "1:93000457080:web:6306f432c8f8ad186e468d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export  const auth = getAuth(app);

export const db = getFirestore(app);